import type { UserBillingDetailsQuery } from '@repo/cf-user/gen/user'
import { defaultCurrency } from 'cf-i18n/constants'
import { COUNTRY_COOKIE_NAME } from 'constants/cookies'
import { getCookie } from 'utils/dom'
import type { PaymentsData } from '../context/payments-dialog-types'
import { isCountry } from './countries'

export function mapUserToPaymentData(user: UserBillingDetailsQuery | undefined): PaymentsData {
  const userData = user?.me?.user ?? null
  const countryCookieValue = getCookie(COUNTRY_COOKIE_NAME)
  const country = userData?.billingDetails.address.country || countryCookieValue

  return {
    firstName: userData?.firstName ?? '',
    lastName: userData?.lastName ?? '',
    email: userData?.email ?? '',
    taxId: userData?.billingDetails.taxId ?? '',
    id: userData?.id ?? '',
    stripeCustomerId: userData?.stripeCustomerId ?? '',
    currency: {
      code: userData?.currency?.code ?? defaultCurrency.code,
      symbol: userData?.currency?.symbol ?? defaultCurrency.symbol,
    },
    address: {
      line1: userData?.billingDetails.address.line1 ?? '',
      line2: userData?.billingDetails.address.line2 ?? '',
      city: userData?.billingDetails.address.city ?? '',
      state: userData?.billingDetails.address.state ?? '',
      postalCode: userData?.billingDetails.address.postalCode ?? '',
      country: isCountry(country) ? country : 'US',
    },
  }
}
